import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../dataService.service';
import{UserInfo} from '../userInfo'


@Component({
  selector: 'app-slides',
  templateUrl: './slides.component.html',
  styleUrls: ['./slides.component.css']
})
export class SlidesComponent implements OnInit {

  @Input() UserInfos:UserInfo;
  rowIndex =0;
  constructor(private dataservices:DataService) { 

  }

 
 
  ngOnInit() {
  }

}
